export default "__VITE_ASSET__DLbG5wby__"